import { Component, Input } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { BehaviorSubject } from 'rxjs';

/*
 ** Map Filter
 ** Render a Map Filter
 */
@Component({
  selector: 'map-filter',
  templateUrl: './map-filter.component.html',
  styleUrls: ['./map-filter.component.scss'],
})
export class MapFilterComponent {
  @Input() properties: BehaviorSubject<any>;
  Icon = Icon;

  filterShow: boolean[] = [false];

  onShowFilter(i: any) {
    this.filterShow[i] = !this.filterShow[i];
  }
}
